var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.33333H19.5M15 4.33333L14.6956 3.43119C14.4005 2.55694 14.2529 2.11982 13.9793 1.79664C13.7376 1.51126 13.4274 1.29036 13.0768 1.1542C12.6798 1 12.2134 1 11.2803 1H9.7197C8.78663 1 8.3202 1 7.9232 1.1542C7.57266 1.29036 7.26234 1.51126 7.0207 1.79664C6.74706 2.11982 6.59954 2.55694 6.30447 3.43119L6 4.33333M17.25 4.33333V15.6667C17.25 17.5336 17.25 18.4669 16.8821 19.18C16.5586 19.8072 16.0423 20.3171 15.4072 20.6367C14.6852 21 13.7402 21 11.85 21H9.15C7.25982 21 6.31473 21 5.59278 20.6367C4.95773 20.3171 4.44143 19.8072 4.11785 19.18C3.75 18.4669 3.75 17.5336 3.75 15.6667V4.33333M12.75 8.77778V16.5556M8.25 8.77778V16.5556",
    stroke: "#FF725E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.64a1cad7c5d8c5f3bf64ec7e390b1b0a.svg";
export { ForwardRef as ReactComponent };